// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kRW8","input":"styles_input__26a14"};